<template>
  <div id="NextSteps">
      <usc-hero :title="this.hero.title" :loResSrc="this.hero.loResSrc" :hiResSrc="this.hero.hiResSrc" :color="this.page.color"></usc-hero>
      <usc-intro :copy="this.intro">
      </usc-intro>
      <div class="body mb gutter-lg">
        <p>Following is a guide to a few of the lingering questions you may have and final steps to take to enroll at Marshall.</p>
        <p><strong>Still Undecided?</strong></p>
        <p>Explore the <a class="inline-hyperlink" href="https://www.marshall.usc.edu/programs/undergraduate-programs" target="_blank">degree of difference</a> USC Marshall offers or contact <a href="mailto:busadm@marshall.usc.edu" class="inline-hyperlink" target="_blank">Marshall undergraduate admissions</a> or call us at (213) 740-8885 with any remaining questions you have or information you need. </p>
        <p></p>
        <p></p>
      </div>


      <!-- <usc-videoEmbed :frameTitle="this.video1.frameTitle" :caption="this.video1.caption" :videoSource="this.video1.src"></usc-videoEmbed> -->
      <usc-videoEmbed :frameTitle="this.video2.frameTitle" :caption="this.video2.caption" :videoSource="this.video2.src"></usc-videoEmbed>

      <div class="body gutter-lg mb">
        <p><strong>Exam Credits</strong><br /><i>Advanced Placement Exam Scores</i><br />If you are taking advanced placement examinations this spring, be sure to list USC as your college choice so that your scores will be sent to the University Admissions Office. To submit previous AP exam results, contact <a href="https://www.collegeboard.org/" class="inline-hyperlink" target="_blank">College Board</a> to have your scores delivered directly to USC. USC’s CEEB code is 4852.</p>
        <p>Students receive four USC units for most AP exams passed with a minimum score of 4. A maximum of 32 units can be awarded for AP exams.</p>
        <p>For advising purposes, bring copies of your AP scores to Orientation.</p>
        <p><i>International Baccalaureate Diplomas</i><br />USC awards a maximum of 24 credits for the International Baccalaureate (IB) exams. For each IB Higher Level exam with a score of 5, 6, or 7, USC awards 6 semester units, up to a maximum of 4 subject exams. Alternatively, USC awards 20 semester units for students who earn the International Baccalaureate Diploma with a score of 30 or above.</p>
        <p><i>A-Level Exam Credit</i><br />USC awards 8 elective semester units for A-level exams earning scores of A*, A or B. <br /> Students may receive General Education (GE) or USC Marshall prerequisite subject credit. The USC Articulation Office determines whether courses transfer for degree credit, fulfill any GE or diversity categories or receive USC course equivalencies.</p>
        <p>Learn more about <a href="https://arr.usc.edu/students/transfer-credit-services/exam-credit/" class="inline-hyperlink" target="_blank">AP, IB and A-Level exam credits</a>.</p>
        <p><strong>Enrollment Commitment Deposit</strong><br />Admitted freshmen must submit the <a href="https://fallwelcome.usc.edu/next-steps/" class="inline-hyperlink" target="_blank">Enrollment Commitment Deposit</a> by May 1 to reserve a place in the fall class. The deposit must be received and processed before you can register for Orientation.</p>
        <p><strong>Housing and Meal Plan Application</strong><br />Admitted students should submit a Housing Application as early as possible because they are processed in the order received. Learn more about the process of <a href="https://housing.usc.edu/index.php/application-4/" class="inline-hyperlink" target="_blank">choosing your housing options</a>. You can submit your Housing Application before the Enrollment Commitment Deposit. You have numerous <a href="https://hospitality.usc.edu/residential-dining-meal-plans/" class="inline-hyperlink" target="_blank">options for meal plans</a> as well.</p>
        <p><strong>Final Transcript</strong><br />Submit a final transcript after completing your last semester.</p>
      </div>

      <div class="body mb gutter-lg">
        <h2>Orientation</h2>
        <p>USC’s Orientation Programs team helps ensure a smooth transition and warm welcome to the USC community for all new students. We believe Orientation is a process, not just an event, so we host programs and activities throughout the academic year to facilitate your transition to life as a Trojan.</p>
        <usc-cta text="Sign up for Orientation" url="https://orientation.usc.edu/sign-up/"></usc-cta>
      </div>

      <!-- <usc-videoEmbed :frameTitle="this.video3.frameTitle" :caption="this.video3.caption" :videoSource="this.video3.src"></usc-videoEmbed> -->

      <div class="body mb gutter-lg">
        <h2>At Orientation, you will:</h2>
        <ul>
          <li>Receive academic advisement</li>
          <li>Complete class registration</li>
          <li>Get a USCard</li>
          <li>Sign up for health insurance (or provide proof of existing insurance)</li>
          <li>Purchase a USC Parking Permit (if needed)</li>
          <li>Register your bicycle (if needed)</li>
          <li>Meet faculty, staff and fellow students</li>
          <li>Learn important facts about life on campus</li>
        </ul>
      </div>
      <usc-callout-link urltext="Count me in!" url="https://applyto.usc.edu/apply/status"></usc-callout-link>
  </div>
</template>

<script>

import hero from '@/components/Hero'
import intro from '@/components/Intro'
import cta from '@/components/Cta'
import videoEmbed from '@/components/videoEmbed'
import CalloutLink from '@/components/CalloutLink'

export default {
  name: 'NextSteps',
  components: {
    'usc-hero': hero,
    'usc-intro': intro,
    'usc-cta': cta,
    'usc-videoEmbed': videoEmbed,
    'usc-callout-link': CalloutLink
  },
  data () {
    return {
      page: {
        color: '#ffcc00'
      },
      hero: {
        title: 'NextSteps',
        loResSrc: '../../static/HeroImages/Marshall39.jpg',
        hiResSrc: '../../static/HeroImages/Marshall39.jpg'
      },
      intro: [
        'Congratulations again on your admission to USC Marshall. We can’t wait to welcome you into the Trojan Family!'
      ],
      video1: {
        caption: 'Dean Ellis answers common parent\'s questions',
        src: 'https://player.vimeo.com/video/249455589?title=0&byline=0&portrait=0',
        frameTitle: 'Video: Dean Ellis answers questions'
      },
      video2: {
        caption: 'Why parents choose Marshall',
        src: 'https://player.vimeo.com/video/249455704?title=0&byline=0&portrait=0',
        frameTitle: 'Video: Why parents choose Marshall'
      },
      video3: {
        caption: 'What students discover at Explore USC',
        src: 'https://player.vimeo.com/video/249455984?title=0&byline=0&portrait=0',
        frameTitle: 'Video: Explore USC'
      }
    }
  },
  created () {
    this.$root.setPageHeader('Next Steps', '')
  }
}
</script>
<style scoped lang="scss">
  ul {
    margin-left: 1em;
  }

  li {
    margin-left: 1em;
    padding-left: 1em;
    list-style-type: disc;
  }
</style>



// WEBPACK FOOTER //
// src/pages/NextSteps.vue